module.exports = __webpack_public_path__ + "static/media/highlight.30773000.png";